module.exports = __webpack_public_path__ + "fonts/icomoon.c25ab22.woff";